import React, { Component } from 'react';
import PlaceMarlagne from './PlaceMarlagne.js';
import PlaceCoudenberg from './PlaceCoudenberg'
import PlaceSPOTT from './PlaceSPOTT'
import PlaceDeltaTambour from './PlaceDeltaTambour'
import PlaceDeltaGrandeSalle from './PlaceDeltaGrandeSalle'
import PlaceDeltaMediator from './PlaceDeltaMediator'
import PlaceMalonneSaintBerthuin from './PlaceMalonneSaintBerthuin'
import PlaceFunEnBulles from './PlaceFunEnBulles'
import PlaceSambrevilleTheatre from './PlaceSambrevilleTheatre'
import PlaceNamurConcertHall from './PlaceNamurConcertHall'

// This component manage the place seat map. It accepts/requires the following properties: 
// - place (mandatory): the name of the place to be represented
// - seats (mandatory): a NadheoPlaceSeat object containing the different seats status
// - freeColour (string): colour for the free seats (first category)
// - freeColourLastCategory (string): colour for the free seats of the last category. Each intermediate category will
//   take a colour in the gradient between freeColour and freeColourLastCategory. The seat categories are sorted
//   alphabetically by name.
// - paidColour (string): colour for the paid seats
// - bufferedColour (string): colour for the buffer seats
// - bookedColour (string): colour for the booked seats
// - highlightedColour (string): colour for the highlighted seats
// - isolatedColour (string): colour for the isolated seats
// - notforsaleColour (string): colour for the seats that are not for sale
// - legend (Array [{Colour: String, Text: String}]): Legend of the seat colour
// - showLegend (boolean): if the legend must appear
// - onSeatClick (function(seatGroupName, seatName, seatColour, mouseClickEvent): callback function when the user clicks on a seat
// - onHandiSeatClick (function): callback function when the user clicks on a PMR seat
// - onMouseSeatEnter (function(seatGroup, seatName, x, y): indicate that the mouse pointed entered a seat space
// - onMouseSeatLeave (function(seatGroup, seatName): indicate that the mouse pointed left a seat space
// - width (optional): the width of the image
class NadheoPlaceMap extends Component {

  render() {
    switch (this.props.place) {
      case "Théâtre de la Marlagne": 
        return <PlaceMarlagne seats={this.props.seats}
                              freeColour={this.props.freeColour}
                              freeColourLastCategory={this.props.freeColourLastCategory}
                              paidColour={this.props.paidColour}
                              bookedColour={this.props.bookedColour}
                              highlightedColour={this.props.highlightedColour}
                              isolatedColour={this.props.isolatedColour}
                              bufferedColour={this.props.bufferedColour}
                              notforsaleColour={this.props.notforsaleColour}
                              legend={this.props.legend}
                              showLegend={this.props.showLegend}
                              onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                              onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                              onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                              onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                              width={this.props.width} />;
      case "Saint-Jacques Coudenberg Bruxelles":
        return <PlaceCoudenberg seats={this.props.seats}
                                freeColour={this.props.freeColour}
                                freeColourLastCategory={this.props.freeColourLastCategory}
                                paidColour={this.props.paidColour}
                                bookedColour={this.props.bookedColour}
                                highlightedColour={this.props.highlightedColour}
                                isolatedColour={this.props.isolatedColour}
                                bufferedColour={this.props.bufferedColour}
                                notforsaleColour={this.props.notforsaleColour}
                                legend={this.props.legend}
                                showLegend={this.props.showLegend}
                                onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                                onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                                onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                                onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                                width={this.props.width} />;
      case "SPOTT":
        return <PlaceSPOTT seats={this.props.seats}
                           freeColour={this.props.freeColour}
                           freeColourLastCategory={this.props.freeColourLastCategory}
                           paidColour={this.props.paidColour}
                           bookedColour={this.props.bookedColour}
                           highlightedColour={this.props.highlightedColour}
                           isolatedColour={this.props.isolatedColour}
                           bufferedColour={this.props.bufferedColour}
                           notforsaleColour={this.props.notforsaleColour}
                           legend={this.props.legend}
                           showLegend={this.props.showLegend}
                           onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                           onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                           onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                           onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                           width={this.props.width} />;
      case "Delta - Tambour":
        return <PlaceDeltaTambour seats={this.props.seats}
                                  freeColour={this.props.freeColour}
                                  freeColourLastCategory={this.props.freeColourLastCategory}
                                  paidColour={this.props.paidColour}
                                  bookedColour={this.props.bookedColour}
                                  highlightedColour={this.props.highlightedColour}
                                  isolatedColour={this.props.isolatedColour}
                                  bufferedColour={this.props.bufferedColour}
                                  notforsaleColour={this.props.notforsaleColour}
                                  legend={this.props.legend}
                                  showLegend={this.props.showLegend}
                                  onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                                  onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                                  onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                                  onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                                  width={this.props.width} />;
      case "Delta - Médiator":
        return <PlaceDeltaMediator seats={this.props.seats}
                                   freeColour={this.props.freeColour}
                                   freeColourLastCategory={this.props.freeColourLastCategory}
                                   paidColour={this.props.paidColour}
                                   bookedColour={this.props.bookedColour}
                                   highlightedColour={this.props.highlightedColour}
                                   isolatedColour={this.props.isolatedColour}
                                   bufferedColour={this.props.bufferedColour}
                                   notforsaleColour={this.props.notforsaleColour}
                                   legend={this.props.legend}
                                   showLegend={this.props.showLegend}
                                   onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                                   onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                                   onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                                   onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                                   width={this.props.width} />;
      case "Delta - Grande salle":
        return <PlaceDeltaGrandeSalle seats={this.props.seats}
                                      freeColour={this.props.freeColour}
                                      freeColourLastCategory={this.props.freeColourLastCategory}
                                      paidColour={this.props.paidColour}
                                      bookedColour={this.props.bookedColour}
                                      highlightedColour={this.props.highlightedColour}
                                      isolatedColour={this.props.isolatedColour}
                                      bufferedColour={this.props.bufferedColour}
                                      notforsaleColour={this.props.notforsaleColour}
                                      legend={this.props.legend}
                                      showLegend={this.props.showLegend}
                                      onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                                      onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                                      onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                                      onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                                      width={this.props.width} />;
      case "Malonne - Salle Saint-Berthuin":
        return <PlaceMalonneSaintBerthuin seats={this.props.seats}
                                          freeColour={this.props.freeColour}
                                          freeColourLastCategory={this.props.freeColourLastCategory}
                                          paidColour={this.props.paidColour}
                                          bookedColour={this.props.bookedColour}
                                          highlightedColour={this.props.highlightedColour}
                                          isolatedColour={this.props.isolatedColour}
                                          bufferedColour={this.props.bufferedColour}
                                          notforsaleColour={this.props.notforsaleColour}
                                          legend={this.props.legend}
                                          showLegend={this.props.showLegend}
                                          onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                                          onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                                          onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                                          onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                                          width={this.props.width} />;
      case "Salle Fun en Bulles":
        return <PlaceFunEnBulles seats={this.props.seats}
                                 freeColour={this.props.freeColour}
                                 freeColourLastCategory={this.props.freeColourLastCategory}
                                 paidColour={this.props.paidColour}
                                 bookedColour={this.props.bookedColour}
                                 highlightedColour={this.props.highlightedColour}
                                 isolatedColour={this.props.isolatedColour}
                                 bufferedColour={this.props.bufferedColour}
                                 notforsaleColour={this.props.notforsaleColour}
                                 legend={this.props.legend}
                                 showLegend={this.props.showLegend}
                                 onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                                 onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                                 onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                                 onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                                 width={this.props.width} />;
      case "Centre Culturel de Sambreville - Théâtre":
        return <PlaceSambrevilleTheatre seats={this.props.seats}
                                        freeColour={this.props.freeColour}
                                        freeColourLastCategory={this.props.freeColourLastCategory}
                                        paidColour={this.props.paidColour}
                                        bookedColour={this.props.bookedColour}
                                        highlightedColour={this.props.highlightedColour}
                                        isolatedColour={this.props.isolatedColour}
                                        bufferedColour={this.props.bufferedColour}
                                        notforsaleColour={this.props.notforsaleColour}
                                        legend={this.props.legend}
                                        showLegend={this.props.showLegend}
                                        onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                                        onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                                        onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                                        onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                                        width={this.props.width} />;
      case "Namur Concert Hall":
        return <PlaceNamurConcertHall seats={this.props.seats}
                                      freeColour={this.props.freeColour}
                                      freeColourLastCategory={this.props.freeColourLastCategory}
                                      paidColour={this.props.paidColour}
                                      bookedColour={this.props.bookedColour}
                                      highlightedColour={this.props.highlightedColour}
                                      isolatedColour={this.props.isolatedColour}
                                      bufferedColour={this.props.bufferedColour}
                                      notforsaleColour={this.props.notforsaleColour}
                                      legend={this.props.legend}
                                      showLegend={this.props.showLegend}
                                      onSeatClick={(this.props.onSeatClick === undefined)?(() => {}):this.props.onSeatClick}
                                      onHandiSeatClick={(this.props.onHandiSeatClick === undefined)?(() => {}):this.props.onHandiSeatClick}
                                      onMouseSeatEnter={(this.props.onMouseSeatEnter === undefined)?(() => {}):this.props.onMouseSeatEnter}
                                      onMouseSeatLeave={(this.props.onMouseSeatLeave === undefined)?(() => {}):this.props.onMouseSeatLeave}
                                      width={this.props.width} />;
      default:
        throw new Error("Map does not exist for the place "+ this.props.place);
    }
  }
}
export default NadheoPlaceMap;
